module.exports = __webpack_public_path__ + "img/id-card-clip.ebdce553.svg";